import { CircleAlert, CircleCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { PackagingFieldCrossCheckIssueCode } from '@/shared/hooks/api/packagingSuppliers'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'
import { auditIssueLabelKey } from './packagingSupplierOverviewColumns'

type PackagingSupplierRedFlagsCellProps = {
  redFlags: PackagingFieldCrossCheckIssueCode[]
}

export function PackagingSupplierRedFlagsCell({
  redFlags,
}: PackagingSupplierRedFlagsCellProps) {
  const { t } = useTranslation('packagingSuppliers')

  if (redFlags.length === 0) {
    const ariaLabel = t('fieldCrossCheck.clear')
    return (
      <HoverCard>
        <HoverCardTrigger asChild>
          <button
            type='button'
            className='inline-flex rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
            aria-label={ariaLabel}
            onClick={(event) => event.stopPropagation()}
          >
            <CircleCheck className='size-4 text-green-600 dark:text-green-500' aria-hidden />
          </button>
        </HoverCardTrigger>
        <HoverCardContent className='w-80 max-w-sm p-4' align='start' side='top'>
          <p className='text-sm text-popover-foreground'>{ariaLabel}</p>
        </HoverCardContent>
      </HoverCard>
    )
  }

  const summaryLabel = t('list.redFlags.hoverTitle')

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <button
          type='button'
          className='inline-flex rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          aria-label={summaryLabel}
          onClick={(event) => event.stopPropagation()}
        >
          <CircleAlert className='size-4 text-destructive' aria-hidden />
        </button>
      </HoverCardTrigger>
      <HoverCardContent className='w-80 max-w-sm p-4' align='start' side='top'>
        <ul className='space-y-3'>
          {redFlags.map((code) => (
            <li key={code} className='flex items-start gap-2'>
              <CircleAlert
                className='mt-0.5 size-4 shrink-0 text-destructive'
                aria-hidden
              />
              <div className='min-w-0 space-y-0.5'>
                <p className='text-sm font-medium text-popover-foreground'>
                  {t(auditIssueLabelKey(code))}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </HoverCardContent>
    </HoverCard>
  )
}
